import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const coachingTasksState = (state: RootState) => state.scene.dashboard.coaching.tasks;

export const getCoachingTasks = createSelector(coachingTasksState, ({ tasks }) => tasks);

export const isCoachingTasksLoading = createSelector(coachingTasksState, ({ loading }) => loading);

export const isCoachingTasksLoadingMore = createSelector(
  coachingTasksState,
  ({ loadingMore }) => loadingMore
);

export const getCoachingTasksTotal = createSelector(coachingTasksState, ({ total }) => total);

export const isCoachingTaskCreating = createSelector(
  coachingTasksState,
  ({ createLoading }) => createLoading
);

export const getCoachingTasksToggleCompleteLoadingIds = createSelector(
  coachingTasksState,
  ({ toggleCompleteLoadingIds }) => toggleCompleteLoadingIds
);

export const getCoachingTasksDeleteLoadingIds = createSelector(
  coachingTasksState,
  ({ deleteLoadingIds }) => deleteLoadingIds
);

export const getCoachingTasksUpdateLoadingIds = createSelector(
  coachingTasksState,
  ({ updateLoadingIds }) => updateLoadingIds
);

export const getCoachingTasksRefreshCounter = createSelector(
  coachingTasksState,
  ({ refreshCounter }) => refreshCounter
);

export const getCoachingTaskMentionsMap = createSelector(
  coachingTasksState,
  ({ mentionsByTaskId }) => mentionsByTaskId
);

export const getEditingCoachingTaskId = createSelector(
  coachingTasksState,
  ({ editingTaskId }) => editingTaskId
);

export const getEditingCoachingTaskOutOfFilter = createSelector(
  coachingTasksState,
  ({ editingTaskOutOfFilter }) => editingTaskOutOfFilter
);

export const getLinkedCoachingTasksById = createSelector(
  coachingTasksState,
  ({ linkedTasksById }) => linkedTasksById
);

export const getSuggestedActionOwner = createSelector(
  coachingTasksState,
  ({ suggestedActionOwner }) => suggestedActionOwner
);

export const isSuggestedActionOwnerLoading = createSelector(
  coachingTasksState,
  ({ suggestedActionOwnerLoading }) => suggestedActionOwnerLoading
);
